module.exports = __webpack_public_path__ + "img/index-5.b31e3bb7.png";